<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">Сквозной порядковый номер</td>
          <td rowspan="2">Дата сварки, температура воздуха, °С</td>
          <td rowspan="2">Диаметр и толщина стенки трубы, мм</td>
          <td rowspan="2">ГОСТ или ТУ, марка стали, завод-поставщик труб</td>
          <td rowspan="2">Температура подогрева (просушки стыка), °С</td>
          <td rowspan="2">Наименование и № свариваемых элементов трубопровода</td>
          <td rowspan="2">Заводские номера труб</td>
          <td colspan="2">Привязка стыка (для неповоротной сварки)</td>
          <td rowspan="2">Способ сварки и положение при сварке</td>
          <td rowspan="2">Марка сварочных материалов</td>
          <td rowspan="2">Фамилия, инициалы бригадира (звеньевого) и номер схемы расположения сварщиков</td>
          <td rowspan="2">Номер шифра бригады или сварщика</td>
          <td rowspan="2">Соблюдение технологии (подпись бригадира)</td>
          <td colspan="2">Приемка стыка</td>
          <td colspan="2">Сведения о проведении ремонта или удалении стыка</td>
          <td colspan="2">Приемка стыка после ремонта</td>
          <td rowspan="2">Примечание</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>километр</td>
          <td>пикет</td>
          <td>по внешнему осмотру подпись прораба (мастера)</td>
          <td>по результатам контроля физическими методами или механическим испытаниям (заключение о годности стыка, номер, дата заключения)</td>
          <td>отремонтирован, удален, дата</td>
          <td>подпись прораба (мастера)</td>
          <td>по внешнему осмотру, подпись прораба, мастера</td>
          <td>по результатам контроля физическими методами (заключение о годности, номер и дата заключения)</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
          <td>21</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }}
      </template>
      <template #recordsSign="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
      </template>
      <template #recordsMasterSign="{item}">
        <c-journal-sign :sign="getSign(item, 'mid.records')" />
        <c-journal-sign :sign="getSign(item, 'master')" />
      </template>
      <template #recordsMasterEndSign="{item}">
        <c-journal-sign :sign="getSign(item, 'end.records')" />
        <c-journal-sign :sign="getSign(item, 'end.master')" />
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_'+this.journal.name+'_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'weldingDate', title: '', },
        { name: 'wallDiameter', title: '', },
        { name: 'gost', title: '', },
        { name: 'tempHeating', title: '', },
        { name: 'title', title: '', },
        { name: 'pipeNumber', title: '', },
        { name: 'weldingKilometer', title: '', },
        { name: 'weldingPiket', title: '', },
        { name: 'weldingWay', title: '', },
        { name: 'weldingMaterialMark', title: '', },
        { name: 'foreman', title: '', },
        { name: 'cipherNumber', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'outLook', title: '', },
        { name: 'physicMethods', title: '', },
        { name: 'fix', title: '', },
        { name: 'recordsMasterSign', title: '', },
        { name: 'recordsMasterEndSign', title: '', },
        { name: 'result', title: '', },
        { name: 'remark', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load() 
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
